import { useQuery } from '@tanstack/react-query';
import { fetchRawData, type RawDataQueryParams } from '../services/rawDataApi';

const RAW_DATA_STALE_TIME_MS = 30 * 1000;
const RAW_DATA_GC_TIME_MS = 5 * 60 * 1000;

export function useRawDataQuery(
  eventId: number | null,
  params: RawDataQueryParams = {}
) {
  return useQuery({
    queryKey: ['raw-data', eventId, params],
    queryFn: () => fetchRawData(eventId ?? 0, params),
    enabled: eventId != null,
    staleTime: RAW_DATA_STALE_TIME_MS,
    gcTime: RAW_DATA_GC_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
